module.exports = __webpack_public_path__ + "img/bahamas.e9f3ec38.svg";